import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const RESET_BET_POSITION_CACHE = 'BET_POSITION :: RESET_BET_POSITION_CACHE';

export type TResetBetPositionCacheAction = IReduxAction<typeof RESET_BET_POSITION_CACHE, string>;

export const resetBetPositionCache = actionGenerator<typeof RESET_BET_POSITION_CACHE, string>(RESET_BET_POSITION_CACHE);
